import { useIntl } from '../../hooks';
import { copyToClipboard } from '../../lib/utils.js';
import { Button, DialogFooter, Label } from '../ui';

export default function DeviceCreatedNotification({
  serial,
  token,
  handleClose,
}: {
  serial: string;
  token: string;
  handleClose: () => void;
}) {
  const intl = useIntl();

  return (
    <>
      <div className="space-y-4">
        <div className="p-4 bg-success-light border border-success rounded-md">
          <p className="text-sm text-success-dark mb-2">
            {intl.formatMessage({ id: 'deviceCreated.successMessage' })}
          </p>

          <div className="space-y-3">
            <div>
              <Label className="text-xs font-semibold text-success-dark">
                {intl.formatMessage({ id: 'deviceCreated.serial' })}:
              </Label>
              <div className="flex items-center space-x-2 mt-1">
                <code className="flex-1 px-2 py-1 bg-background-light border rounded text-xs break-all">
                  {serial}
                </code>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => copyToClipboard(serial)}
                  className="text-xs"
                >
                  {intl.formatMessage({ id: 'deviceCreated.copy' })}
                </Button>
              </div>
            </div>

            <div>
              <Label className="text-xs font-semibold text-success-dark">
                {intl.formatMessage({ id: 'deviceCreated.token' })}:
              </Label>
              <div className="flex items-center space-x-2 mt-1">
                <code className="flex-1 px-2 py-1 bg-background-light border rounded text-xs break-all">
                  {token}
                </code>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => copyToClipboard(token)}
                  className="text-xs"
                >
                  {intl.formatMessage({ id: 'deviceCreated.copy' })}
                </Button>
              </div>
            </div>
          </div>

          <p className="text-xs text-success-dark mt-3">
            ⚠️ {intl.formatMessage({ id: 'deviceCreated.warning' })}
          </p>
        </div>
      </div>

      <DialogFooter>
        <Button onClick={handleClose}>{intl.formatMessage({ id: 'deviceCreated.close' })}</Button>
      </DialogFooter>
    </>
  );
}
